import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment, { lang } from "moment";

import ApiService from "../services/ApiService";
import RegisterWorkConfirmation from "../components/registerwork/registerworkConfirmation";
import RegisterWorkFileUpload from "../components/registerwork/registerworkFileUpload";
import RegisterWorkInformation from "../components/registerwork/registerworkInformation";
import RegisterWorkLicence from "../components/registerwork/registerworkLicence";
import RegisterWorkSave from "../components/registerwork/registerworkSave";
import WorkReview from "../components/registerwork/WorkReview";
import Stepper from "../components/registerwork/Stepper";
import EasyTrans from "../components/bundel/EasyTrans";
import { Button, PageContainer } from "../components/ui";
import UserService from "../services/UserService";
import { useNavigate } from "react-router-dom";

const STEPS = [
  { key: "upload", label: "RegisterWork.Title.UploadWork" },
  { key: "info", label: "RegisterWork.Title.WorkInformation" },
  { key: "license", label: "RegisterWork.Title.AddLicence" },
  { key: "storage", label: "RegisterWork.Title.SecurityAndStorageOptions" },
  { key: "confirm", label: "RegisterWork.Confirmation.Title" },
];

//TODO Notification when limit in SaveOptions reachedS
//TODO Query frequently used tags and display them as an example for users

const RegisterWorkPage = () => {
  const { t } = useTranslation();

  //#region States

  //#region States Fileupload
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [presignedURL, setPresignedURL] = useState("");
  const [prefix, setPrefix] = useState();
  const [filename, setFilename] = useState("");
  const [file, setFile] = useState("");
  //#endregion
  //#region States Information
  const [type, setType] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState([]);
  const [language, setLanguage] = useState("");
  const [creationDate, setCreationDate] = useState();

  //#region States Involed Persons
  const [contributorList, setContributorList] = useState([
    {
      firstName: UserService.getFirstName(),
      lastName: UserService.getLastName(),
      email: UserService.getEMail(),
      pseudonym: "",
      url: "",
      percentage: 100,
    },
  ]);

  const [publisher, setPublisher] = useState("");
  const [attribution, setAttribution] = useState("");

  //#endregion
  //#region Additional Information
  const [identifier, setIdentifier] = useState("");
  const [relation, setRelation] = useState("");
  //#endregion
  //#endregion
  //#region States License
  const [licence, setLicence] = useState("Full Copyright");
  const [dalicc, setDalicc] = useState("");
  //#endregion
  //#region States SaveOptions
  const [visibility, setVisibility] = useState(true);
  const [saveFileSystem, setSaveFileSystem] = useState(true);
  const [saveIpfsSystem, setSaveIpfsSystem] = useState(false);
  const [saveSelfSave, setSaveSelfSave] = useState(false);
  //#endregion
  //#region States CheckedConfirmation
  const [confirmationChecked, setConfirmationChecked] = useState(false);
  //#endregion
  //#region States Error
  const [fileError, setFileError] = useState(false);
  const [typeError, setTypeError] = useState(false);
  const [titleError, setTitleError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [creatorError, setCreatorError] = useState(false);
  const [firstnameError, setFirstnameError] = useState(false);
  const [lastnameError, setLastnameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [pseudonymError, setPseudonymError] = useState(false);
  const [percentageError, setPercentageError] = useState(false);
  const [licenceError, setLicenceError] = useState(false);
  const [confirmationError, setConfirmationError] = useState(false);
  //#region States RegisterCheck
  const [step, setStep] = useState(0);
  //#endregion
  //#endregion
  //#endregion

  //#region Methods

  //#region Methods UseEffect
  useEffect(() => {
    // Two entry modes from external clients (e.g. the Nextcloud plugin):
    //
    //   a) ?prefix=…&filename=…
    //      The file is already in fairregister storage. Just seed the
    //      workFile reference and hide the upload widget.
    //
    //   b) ?fromUrl=…&filename=…
    //      The client (Nextcloud plugin) handed us a temporary public URL
    //      pointing at the file bytes (e.g. an NC share-link). We fetch
    //      the bytes here, then run them through the normal upload flow
    //      to obtain a prefix.
    const urlParams = new URLSearchParams(window.location.search);
    const filenameParam = urlParams.get("filename");
    const prefixParam = urlParams.get("prefix");
    const fromUrlParam = urlParams.get("fromUrl");

    if (filenameParam && prefixParam) {
      setFilename(filenameParam);
      setPrefix(prefixParam);
      setDisableFileUpload(true);
      return;
    }

    if (filenameParam && fromUrlParam) {
      (async () => {
        try {
          setFilename(filenameParam);
          setDisableFileUpload(true);
          const resp = await fetch(fromUrlParam);
          if (!resp.ok) {
            throw new Error(`source returned HTTP ${resp.status}`);
          }
          const blob = await resp.blob();
          // Behave like the FileUpload widget: stream to a presigned URL,
          // capture prefix, then the form is ready to submit.
          await ApiService.uploadWork(
            filenameParam,
            blob,
            setPresignedURL,
            setPrefix,
            () => {},
          );
        } catch (e) {
          console.error("fairregister: fetch-then-upload failed", e);
          setFileError(true);
          setDisableFileUpload(false);
        }
      })();
    }
  }, []);

  //#endregion
  //#region Methods Fileupload
  const onSetPresignedURL = (data) => {
    setPresignedURL(data);
  };
  const onSetPrefix = (data) => {
    setPrefix(data);
  };
  const onSetFile = (data) => {
    setFile(data);
  };
  const onSetFilename = (data) => {
    setFilename(data);
  };
  //#endregion
  //#region Methods Information
  const onSetType = (data) => {
    console.log(data);
    setType(data);
  };
  const onSetTitle = (data) => {
    setTitle(data);
  };
  const onSetDescription = (data) => {
    setDescription(data);
  };
  const onSetTags = (data) => {
    setTags(data);
  };
  const onSetLanguage = (data) => {
    setLanguage(data);
  };
  const onSetCreationDate = (data) => {
    setCreationDate(data);
  };

  //#region Methods Involed Persons
  const onSetContributorList = (data) => {
    setContributorList(data);
  };

  const onSetPublisher = (data) => {
    setPublisher(data);
  };
  const onSetAttribution = (data) => {
    setAttribution(data);
  };

  //#endregion
  //#region Additional Information
  const onSetIdentifier = (data) => {
    setIdentifier(data);
  };
  const onSetRelation = (data) => {
    setRelation(data);
  };
  //#endregion
  //#endregion
  //#region Methods License
  const onSetLicence = (data) => {
    setLicence(data);
  };
  const onSetSaveFileSystem = (data) => {
    setSaveFileSystem(data);
  };
  const onSetDaliccLicence = (data) => {
    setDalicc(data);
  };
  //#endregion
  //#region Methods SaveOptions
  const onSetVisibility = (data) => {
    setVisibility(data);
  };
  const onSetSaveIpfsSystem = (data) => {
    setSaveIpfsSystem(data);
  };
  const onSetSelfSave = (data) => {
    setSaveSelfSave(data);
  };
  //#endregion
  //#region Methods CheckedConfirmation
  const onSetConfirmation = (data) => {
    setConfirmationChecked(data);
  };
  //#endregion
  //#region Methods FinalRegister

  const navigate = useNavigate();

  const prepareType = (type) => {
    return type.toUpperCase();
  };

  const prepareDateData = (date) => {
    return moment(date).toISOString();
  };

  const prepareTagsData = (tags) =>
    (tags || []).map((x) => (typeof x === "string" ? x : x.value));

  const prepareFirstContributor = (contributor) => {
    let preparedContributor = {
      author: {
        id: "",
        firstName: contributor.firstName,
        lastName: contributor.lastName,
        email: contributor.email,
        pseudonym: contributor.pseudonym,
        url: contributor.url,
      },
      percentage: contributor.percentage,
    };

    return preparedContributor;
  };

  const prepareContributor = (contributors) => {
    var preparedContributors = [];
    contributors.shift();
    contributors.map((contributor) =>
      preparedContributors.push({
        author: {
          id: "",
          firstName: contributor.firstName,
          lastName: contributor.lastName,
          email: contributor.email,
          pseudonym: contributor.pseudonym,
          url: contributor.url,
        },
        percentage: contributor.percentage,
      }),
    );
    console.log(preparedContributors);
    return preparedContributors;
  };

  const prepareSaveSystemData = (
    saveFileSystem,
    saveIpfsSystem,
    saveSelfSave,
  ) => {
    let preparedSaveSystemData = [];
    if (saveFileSystem) {
      preparedSaveSystemData.push("FAIRREGISTER_FILE_SYSTEM");
    }

    if (saveIpfsSystem) {
      preparedSaveSystemData.push("IPFS");
    }

    if (saveSelfSave) {
      preparedSaveSystemData.push("OWN_STORAGE");
    }
    return preparedSaveSystemData;
  };

  const prepareVisibility = (visibility) => {
    return visibility ? "PUBLIC" : "PRIVATE";
  };

  const buildRegisterWorkData = () => {
    const preparedFirstContributor = prepareFirstContributor(
      contributorList[0],
    );
    const preparedContributors = prepareContributor([...contributorList]);

    return {
      type: prepareType(type),
      title: title,
      description: description,
      tags: prepareTagsData(tags),
      language: language,
      creationDate: prepareDateData(creationDate),
      registrar: UserService.getUserId(),
      creator: preparedFirstContributor,
      contributors: preparedContributors,
      publisher,
      identifier,
      workFile: {
        prefix,
        filename,
      },
      visibility: prepareVisibility(visibility),
      storageOptions: prepareSaveSystemData(
        saveFileSystem,
        saveIpfsSystem,
        saveSelfSave,
      ),
      license: {
        identifier: licence,
        addons: "",
        dual: "",
        dalicc,
      },
    };
  };

  // Final step: validate everything, then register and go to my-works.
  const onRegister = () => {
    if (!checkValidation()) {
      return;
    }
    ApiService.registerWork(buildRegisterWorkData()).then(() =>
      navigate("/myworks"),
    );
  };

  function scrollTo(id) {
    console.log(id);
    const element = document.getElementById(id);
    console.log(element);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  function checkValidation() {
    var validationCorrect = true;
    var scrollToId = "";
    if (confirmationChecked === false) {
      setConfirmationError(true);
      validationCorrect = false;
    }

    if (!licence) {
      setLicenceError(true);
      scrollToId = "licence";
      validationCorrect = false;
    }

    var validateContributor = contributorList[0];

    var validateFirstName = validateContributor.firstName;
    var validateLastName = validateContributor.lastName;
    var validateEmail = validateContributor.email;
    var validatePseudonym = validateContributor.pseudonym;
    var validatePercentage = validateContributor.percentage;

    if (!validateFirstName) {
      setFirstnameError(true);
      scrollToId = "information";
      validationCorrect = false;
    }

    if (!validateLastName) {
      setLastnameError(true);
      scrollToId = "information";
      validationCorrect = false;
    }

    if (!validateEmail) {
      setEmailError(true);
      scrollToId = "information";
      validationCorrect = false;
    }

    if (!validatePseudonym) {
      setPseudonymError(true);
      scrollToId = "information";
      validationCorrect = false;
    }

    if (!validatePercentage) {
      setPercentageError(true);
      scrollToId = "information";
      validationCorrect = false;
    }

    if (!contributorList[0]) {
      setCreatorError(true);
      scrollToId = "information";
      validationCorrect = false;
    }

    if (!description) {
      setDescriptionError(true);
      scrollToId = "information";
      validationCorrect = false;
    }

    if (!title) {
      setTitleError(true);
      scrollToId = "information";
      validationCorrect = false;
    }

    if (!type) {
      setTypeError(true);
      scrollToId = "information";
      validationCorrect = false;
    }

    if (!filename) {
      setFileError(true);
      scrollToId = "fileupload";
      validationCorrect = false;
    }

    if (scrollToId) {
      scrollTo(scrollToId);
    }

    return validationCorrect; //CancelPost
  }

  // Per-step validation for the wizard; sets the same error states as the
  // final checkValidation, but only for the fields of the current step.
  // Validate the current step; returns the DOM id of the first invalid field
  // (or null when valid) so Next can scroll to it.
  function firstInvalidField(index) {
    if (index === 0) {
      if (!filename) {
        setFileError(true);
        return "fileupload";
      }
      return null;
    }
    if (index === 1) {
      let firstId = null;
      const c = contributorList[0] || {};
      const check = (value, setError, id) => {
        if (!value) {
          setError(true);
          if (!firstId) firstId = id;
        }
      };
      check(type, setTypeError, "information");
      check(title, setTitleError, "title");
      check(description, setDescriptionError, "description");
      check(c.firstName, setFirstnameError, "firstname");
      check(c.lastName, setLastnameError, "lastname");
      check(c.email, setEmailError, "email");
      check(c.pseudonym, setPseudonymError, "pseudonym");
      check(c.percentage, setPercentageError, "percent");
      const totalShare = contributorList.reduce(
        (sum, x) => sum + (Number(x.percentage) || 0),
        0,
      );
      if (totalShare > 100 && !firstId) {
        setPercentageError(true);
        firstId = "percent";
      }
      return firstId;
    }
    if (index === 2) {
      if (!licence) {
        setLicenceError(true);
        return "licence";
      }
      return null;
    }
    return null; // storage step has sensible defaults
  }

  const goToStep = (index) => {
    setStep(index);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const onNext = () => {
    const errorId = firstInvalidField(step);
    if (errorId) {
      const el = document.getElementById(errorId);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    goToStep(Math.min(step + 1, STEPS.length - 1));
  };

  const onBack = () => goToStep(Math.max(step - 1, 0));

  //#endregion

  //#region View
  return (
    <>
      <div className="flex min-h-screen flex-col">
        <div className="flex-grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8">
          <Stepper steps={STEPS} current={step} onStepClick={goToStep} />
        </div>

        <div className={step === 0 ? "" : "hidden"} id="fileupload">
          <RegisterWorkFileUpload
            onSetFile={onSetFile}
            file={file}
            onSetFilename={onSetFilename}
            filename={filename}
            onSetPresignedURL={onSetPresignedURL}
            onSetPrefix={onSetPrefix}
            prefix={prefix}
            fileError={fileError}
            setFileError={setFileError}
            alreadyUploaded={disableFileUpload}
          ></RegisterWorkFileUpload>
        </div>
        <div className={step === 1 ? "" : "hidden"} id="information" />
        <div className={step === 1 ? "" : "hidden"}>
        <RegisterWorkInformation
          onSetType={onSetType}
          type={type}
          typeError={typeError}
          setTypeError={setTypeError}
          onSetTitle={onSetTitle}
          title={title}
          titleError={titleError}
          setTitleError={setTitleError}
          onSetDescription={onSetDescription}
          description={description}
          descriptionError={descriptionError}
          setDescriptionError={setDescriptionError}
          contributorList={contributorList}
          onSetContributorList={onSetContributorList}
          creatorError={creatorError}
          setCreatorError={setCreatorError}
          firstnameError={firstnameError}
          setFirstnameError={setFirstnameError}
          lastnameError={lastnameError}
          setLastnameError={setLastnameError}
          emailError={emailError}
          setEmailError={setEmailError}
          pseudonymError={pseudonymError}
          setPseudonymError={setPseudonymError}
          percentageError={percentageError}
          setPercentageError={setPercentageError}
          onSetTags={onSetTags}
          tags={tags}
          onSetLanguage={onSetLanguage}
          language={language}
          onSetCreationDate={onSetCreationDate}
          creationDate={creationDate}
          onSetPublisher={onSetPublisher}
          publisher={publisher}
          onSetAttribution={onSetAttribution}
          attribution={attribution}
          onSetIdentifier={onSetIdentifier}
          identifier={identifier}
          onSetRelation={onSetRelation}
          relation={relation}
        ></RegisterWorkInformation>
        </div>

        <div className={step === 2 ? "" : "hidden"} id="licence" />
        <div className={step === 2 ? "" : "hidden"}>
          <RegisterWorkLicence
            onSetLicence={onSetLicence}
            workType={type}
            licence={licence}
            onSetDaliccLicence={onSetDaliccLicence}
            dalicc={dalicc}
            licenceError={licenceError}
            setLicenceError={setLicenceError}
          ></RegisterWorkLicence>
        </div>

        <div className={step === 3 ? "" : "hidden"}>
          <RegisterWorkSave
            onSetVisibility={onSetVisibility}
            visibility={visibility}
            onSetSaveFileSystem={onSetSaveFileSystem}
            saveFileSystem={saveFileSystem}
            onSetSaveIpfsSystem={onSetSaveIpfsSystem}
            saveIpfsSystem={saveIpfsSystem}
            onSetSelfSave={onSetSelfSave}
            saveSelfSave={saveSelfSave}
          ></RegisterWorkSave>
        </div>

        <div className={step === 4 ? "" : "hidden"}>
          <WorkReview
            filename={filename}
            type={type}
            title={title}
            description={description}
            licence={licence}
            visibility={visibility}
            storageOptions={prepareSaveSystemData(
              saveFileSystem,
              saveIpfsSystem,
              saveSelfSave,
            )}
            contributors={contributorList}
            language={language}
            creationDate={creationDate}
            identifier={identifier}
            tags={tags}
          />
          <RegisterWorkConfirmation
            onSetConfirmation={onSetConfirmation}
            confirmationChecked={confirmationChecked}
            confirmationError={confirmationError}
            setConfirmationError={setConfirmationError}
          ></RegisterWorkConfirmation>
        </div>

        </div>
        {/* sticky wizard navigation */}
        <div className="sticky bottom-0 z-30 border-t border-gray-200 bg-white/90 backdrop-blur">
          <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
            <Button
              variant="secondary"
              onClick={onBack}
              disabled={step === 0}
            >
              <EasyTrans>Navigation.Back</EasyTrans>
            </Button>
            {step < STEPS.length - 1 ? (
              <Button variant="cta" onClick={onNext}>
                <EasyTrans>SearchWorks.Next</EasyTrans>
              </Button>
            ) : (
              <Button variant="cta" onClick={onRegister}>
                <EasyTrans>RegisterWork.Register</EasyTrans>
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
  //#endregion
};

export default RegisterWorkPage;
